import React from 'react';
import axios from 'axios';
import { ErrorPage } from './ErrorPage';
import { ErrorIcon500 } from '../../assets/icons/500ErrorIcon';

interface IErrorBoundary {
  children: any;
}

const ErrorBoundary = (props: IErrorBoundary) => {
  const [err, setErr] = React.useState<any>();
  const statusCode = 500;
  const image = <ErrorIcon500 />;
  const errorTitle = 'Internal Server Error';
  const errorText = 'Oops seems like something went wrong. We’re \nworking on it.';
  const actionButton = (
    <button className="inline-flex items-center px-6 py-3 mt-1 text-base font-medium text-white">Go back</button>
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 500) {
        setErr(err);
      }
      return Promise.reject(error);
    },
  );
  return (
    <div>
      {err && (
        <ErrorPage
          statusCode={statusCode}
          errorTitle={errorTitle}
          errorText={errorText}
          actionButton={actionButton}
        />
      )}
      {props.children}
    </div>
  );
};

export default ErrorBoundary;
